import React, { FC } from 'react';
import cn from 'classnames';

import { Scrollable } from '@catawiki/cata-style';

import styles from './ScrollableList.module.scss';

interface Props {
  children: React.ReactNode;
  itemClassName?: string;
  arrowClassName?: string;
  'data-testid'?: string;
}

export const ScrollableList: FC<Props> = ({
  children,
  itemClassName,
  arrowClassName,
  'data-testid': dataTestId = undefined,
}) => (
  <div data-testid={dataTestId} className={styles.wrapper}>
    <Scrollable
      containerClassName={cn('u-wrapper', styles.container)}
      listClassName={styles.list}
      itemClassName={cn(itemClassName, styles.item)}
      arrowClassName={cn(arrowClassName, styles.arrow)}
    >
      {children}
    </Scrollable>
  </div>
);
